/*
 * $Id:: filterItems.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

const filters = {
    trademark: [
        {
            globalsKey: 'classes',
            filterid: 'NICE_CLASS',
            name: 'classes',
            placeholder: 'application.nice.classification',
            filterOptions: Array.from({ length: 45 }, (_x, i) => `${i + 1}`),
            multiple: true,
        },
        {
            globalsKey: 'draftDates',
            filterid: 'DATES',
            name: 'dates',
            placeholder: 'dates',
        },
    ],
    design: [
        {
            globalsKey: 'draftDates',
            filterid: 'DATES',
            name: 'dates',
            placeholder: 'dates',
        },
    ],
    eservice: [
        {
            globalsKey: 'ipRightTypes',
            filterid: 'IP_RIGHT_TYPE',
            name: 'ipRightType',
            placeholder: 'ip.right.type',
            filterOptions: [],
            multiple: false,
        },
        {
            globalsKey: 'formTypes',
            filterid: 'FILTERING_TYPE',
            name: 'formTypes',
            placeholder: 'form.type',
            filterOptions: [],
            multiple: true,
        },
        {
            globalsKey: 'draftDates',
            filterid: 'DATES',
            name: 'dates',
            placeholder: 'dates',
        },
    ],
};

const trademarksActionOptions = [
    'TM Renewal',
    'TM Transfer',
    'TM Change Owner Details',
    'TM Change Rep/Corr details',
    'TM Generic',
    'TM License Contract',
    'TM Rights in rem',
];

const initiateActions = {
    trademarks: trademarksActionOptions,
    designs: [...trademarksActionOptions, 'TM Withdrawal/Surrender', 'TM Limit G&S'],
};

const getInitiateActions = (category) => initiateActions[category] || [];

const getDropDownFilters = (category) => filters[category] || [];

export default {
    getDropDownFilters,
    getInitiateActions,
};
